
import Vue, { PropType } from 'vue';
import { Wrapper } from './styles';

const MAX_ITEMS = 5;
const MAX_LEFT = (MAX_ITEMS - 1) / 2;

export default Vue.extend({
  name: 'Pagination',
  components: {
    Wrapper,
  },
  props: {
    limit: {
      type: Number,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
    offset: {
      type: Number,
      required: true,
    },
    setOffset: {
      type: Function as PropType<(page: number) => void>,
      required: true,
    },
  },
  data() {
    return {
      current: this.offset,
      pages: 1,
      first: 1,
      max: this.total,
    };
  },
  methods: {
    initialOffset() {
      return this.offset ? Math.ceil(this.offset / this.limit) + 1 : 1;
    },
    setFirst() {
      this.first = Math.max(this.current - MAX_LEFT, 1);
    },
    setValues() {
      this.pages = Math.ceil(this.max / this.limit);
      this.setFirst();
    },
    onPage(page: number) {
      const florNumber = Math.ceil(page);
      this.setOffset(florNumber);
      this.current = florNumber;
    },
  },
  computed: {
    pagesArray(): any[] {
      return Array.from({ length: Math.min(MAX_ITEMS, this.pages) })
        .map((_, index) => {
          const page = index + this.first;

          return page <= this.pages
            ? {
              page,
              active: page === this.current,
            }
            : null;
        })
        .filter(Boolean);
    },
  },
  watch: {
    current() { this.setFirst(); },
    total(value: number) { this.max = value; this.setValues(); },
  },
  created() {
    this.initialOffset();
    this.setValues();
  },
});
